import {Component,Inject,OnInit} from '@angular/core';
import {ListView,TypeComparaison} from "@domain/common/list-view";
import {Sorting} from "@domain/common/list-view/sorting";
import {TypeProfil} from "@domain/user/user";
import {MessageAdminRole} from "@domain/admin/bibliotheque/notification/message-admin-role";
import {RoleSelectItemComponent} from "@components/admin/bibliotheque/notifications/accueil/accueil-detail/add-role-popin/role-select-item/role-select-item.component";
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';

/**
 * Popin de sélection des rôles à ajouter
 *
 * @author Lionel Gimenez
 * @date 31/03/2026
 */
@Component({
    host: {'data-test-id': 'add-role-popin'},
    templateUrl: './add-role-popin.component.html'
})
export class AddRolePopinComponent implements OnInit {
    /** Liste des rôles */
    listeRoles: ListView<MessageAdminRole,RoleSelectItemComponent>;

    /**
     * Constructeur
     *
     * @param data les données en entrée de la popin
     * @param translateService le moteur de traduction
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { idMessage: number },
        private translateService: TranslateService
    ) {
    }

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        //Initialisation de la liste
        this.listeRoles = new ListView<MessageAdminRole,RoleSelectItemComponent>({
            uri: `/controller/MessageAdmin/loadListeRoleNotExist/${this.data.idMessage}`,
            title: this.translateService.instant('admin.bibliotheque.notifications.accueil.detail.ajoutRole.filtreTitle'),
            component: RoleSelectItemComponent,
            isFilter: false,
            defaultOrder: 'libelle',
            listeFilters: [
                {
                    clef: 'fonction',
                    title: this.translateService.instant('admin.bibliotheque.notifications.accueil.detail.tag.profil'),
                    listeValues: [
                        {
                            code: '' + TypeProfil.ASSISTANT,
                            libelle: TypeProfil.getLibelle(this.translateService,TypeProfil.ASSISTANT)
                        },{
                            code: '' + TypeProfil.COLLABORATEUR,
                            libelle: TypeProfil.getLibelle(this.translateService,TypeProfil.COLLABORATEUR)
                        },{
                            code: '' + TypeProfil.COMPTABLE,
                            libelle: TypeProfil.getLibelle(this.translateService,TypeProfil.COMPTABLE)
                        },{
                            code: '' + TypeProfil.FOURNISSEUR,
                            libelle: TypeProfil.getLibelle(this.translateService,TypeProfil.FOURNISSEUR)
                        },{
                            code: '' + TypeProfil.RESPONSABLE,
                            libelle: TypeProfil.getLibelle(this.translateService,TypeProfil.RESPONSABLE)
                        },{
                            code: '' + TypeProfil.SOUS_ADMINISTRATEUR,
                            libelle: TypeProfil.getLibelle(this.translateService,TypeProfil.SOUS_ADMINISTRATEUR)
                        }
                    ]
                },{
                    clef: 'libelle',
                    title: this.translateService.instant('admin.bibliotheque.notifications.accueil.detail.tag.libelle'),
                    typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                    isDefault: true
                }
            ]
        });

        //Définition des colonnes de tri
        this.listeRoles.columns = [
            {key: 'libelle',title: 'admin.bibliotheque.notifications.accueil.detail.libelle'},
            {key: 'fonction',title: 'admin.bibliotheque.notifications.accueil.detail.fonction'}
        ];

        //Ajout du tri de la liste selon l'ordre voulu
        this.listeRoles.sorting = new Sorting(this.listeRoles.columns,'libelle');
    }

    /**
     * Sélectionne tous les rôles
     */
    onSelectAll(): void {
        this.listeRoles.selectAll(true);
    }

    /**
     * Désélectionne tous les rôles
     */
    onUnselectAll(): void {
        this.listeRoles.selectAll(false);
    }
}
